<template>
  <div class="drugExcess">
    <el-button icon="el-icon-refresh" @click="$refresh(getDrugExcesssList)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="药品名称">
            <el-input v-model.trim="searchForm.drugName" placeholder="请输入药品名称"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getDrugExcesssList, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getDrugExcesssList, { drugName: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="adddrugExcess">新增超量</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="deletedrugExcessList">批量删除</el-button>
      </div>
      <!-- 药品超量信息列表 -->
      <el-table v-loading="loading" :max-height="tableHeight" :data="drugExcessList"
        ref="multipleTable" @selection-change="val => $handleSelectionChange(val, true)" border>
        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="drugName" label="名称"/>
        <el-table-column prop="number" label="数值"/>
        <el-table-column prop="unit" label="单位"/>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="editdrugExcess(scope.row)">编辑</el-button>
            <el-button icon="el-icon-delete" type="danger" @click="deletedrugExcess(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="350px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="药品选择" prop="drugName">
            <el-select v-model="editForm.drugName" remote :remote-method="getDrugsList" filterable default-first-option placeholder="请输入关键字查询药品" @change="setDrugExcess">
              <el-option v-for="item in drugOptions" :key="item.drugId" :label="item.drugName" :value="item.drugName" :disabled="item.disabled"/>
            </el-select>
          </el-form-item>
          <el-form-item label="超量数值" prop="number">
            <el-input v-model.trim="editForm.number" oninput="value=value.replace(/[^\d.]/g,'')" clearable placeholder="请输入药品超量信息数值"/>
          </el-form-item>
          <el-form-item label="药品单位" prop="unit">
            <el-input v-model.trim="editForm.unit" disabled/>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增药品超量信息'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑药品超量信息'" @click="editSave">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getDrugExcesssList)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </div>
</template>

<script lang="js">
import { drugExcessList, drugExcessEdit, drugExcessAdd, drugExcessDelete } from "@/api/drugexcess"; // 药品超量信息请求
import { drugList } from "@/api/drug"; // 药品请求
export default {
  name: 'DrugExcess',
  data() {
    return {
      loading: true, // 加载中
      searchForm: { drugName: null }, // 查询表单
      drugExcessList: [], // 药品超量信息列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      multipleSelection: [], //选项
      drugOptions: [], // 药品选相
      editFormRules: {
        drugName: [{required: true, message: "药品名称不能为空！", trigger: "blur"}],
        number: [{required: true, message: "药品超量信息数值不能为空！"}],
        unit: [{required: true}],
      }, // 验证规则
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.getDrugExcesssList(); // 获取药品超量信息列表
  },
  methods: {
    // 请求所有药品超量信息列表
    async getDrugExcesssList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await drugExcessList(params);
      
      if (code == 200) {
        this.total = total;
        this.drugExcessList = rows;
      }
      this.loading = false;
    },
    // 请求药品列表
    async getDrugsList(query) {
      if (query != '' && query != null) {
        let { rows, code } = await drugList({ searchValue: query });
        if (code == 200) {
          rows.forEach(item => {
            item.disabled = false;
            this.drugExcessList.forEach(items => {
              if (item.drugName == items.drugName) item.disabled = true
            });
          });
          this.drugOptions = rows;
          this.$forceUpdate();
        }
      }
    },
    // 新增药品超量信息
    adddrugExcess() {
      this.dialogVisible = true;
      this.dialogTitle = "新增药品超量信息";
      this.editForm = { drugName: null, number: null, unit: null };
    },
    // 设置超量
    setDrugExcess(val) {
      this.drugOptions.forEach(item => {
        if (item.drugName == val) this.editForm.unit = item.unit;
      })
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          drugExcessAdd(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("新增药品超量信息成功！");

            this.dialogVisible = false;
            this.$refresh(this.getDrugExcesssList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 编辑药品超量信息信息
    async editdrugExcess(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogTitle = "编辑药品超量信息";
      this.dialogVisible = true;
    },
    // 保存药品超量信息修改
    async editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          drugExcessEdit(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("修改药品超量信息成功！");

            this.dialogVisible = false;
            this.$refresh(this.getDrugExcesssList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 删除药品超量信息
    deletedrugExcess(row) {
      this.$confirm('确认删除该药品超量信息？').then(_ => { this.del(row.drugExcessId) }).catch(_ => {});
    },
    async del(id) {
      let { code } = await drugExcessDelete(id);
      if (code == 200) this.$message.success("删除药品超量信息成功！");
      this.$refresh(this.getDrugExcesssList);
    },
    // 药品超量信息批量删除
    deletedrugExcessList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何药品超量信息！");
      else {
        selected.forEach(item => { selectedId.push(item.drugExcessId) });
        this.$confirm('确认删除该药品超量信息？').then(_ => { this.del(selectedId) }).catch(_ => {});
      }
    }
  },
};
</script>

<style lang="less" scoped>
  .drugExcess {
    box-sizing: border-box;
    padding: 20px;
  }
</style>